import i18n from 'i18n';
import { ColGroupDef } from '@ag-grid-enterprise/all-modules';
import { UtimacoCircuitSwitch } from 'data/utimacoCircuitSwitch/utimacoCircuitSwitch.types';

export enum UtimacoCircuitSwitchActionsType {
  Delete = 'delete',
  Edit = 'edit',
  View = 'view'
}

export const newUtimacoCircuitSwitch: UtimacoCircuitSwitch = {
  id: '',
  CFID: '',
  AFID: '',
  ISDN: '',
  LEA: '',
  CCCMCID: '',
  CUGILC: '',
  CUGDNIC: '',
  CPRISDN: ''
};

export const circuitSwitchColumnDefs: ColGroupDef[] = [
  {
    headerName: '',
    children: [
      {
        headerName: i18n.t('utimacoCircuitSwitch.grid.lea'),
        field: 'LEA',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'LEA',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoCircuitSwitch.grid.accessFunction'),
        field: 'AFID',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'AFID',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoCircuitSwitch.grid.collectionFunction'),
        field: 'CFID',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        tooltipField: 'CFID',
        flex: 1,
        minWidth: 198,
      },
      {
        headerName: i18n.t('utimacoCircuitSwitch.grid.isdn'),
        field: 'ISDN',
        sortable: true,
        filter: 'agTextColumnFilter',
        floatingFilter: true,
        resizable: true,
        flex: 1,
        minWidth: 198,
      }
    ],
  },
];
